// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__pmHkU","image":"Header_image__24Mph","name":"Header_name__2DXm2","info":"Header_info__GrjQd","infoRow":"Header_infoRow__GOSxh"};